import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  selectedFileName: null,
};

const documentSlice = createSlice({
  name: 'document',
  initialState,
  reducers: {
    setDocument(state, action) {
      state.selectedFileName = action.payload.fileName;
    },
    clearDocument(state) {
      state.selectedFileName = null;
    },
  },
});

export const { setDocument, clearDocument } = documentSlice.actions;
export default documentSlice.reducer;
